var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 365.2,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.0 0.0 490.0 365.2",
    width: 490,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5,165.4c0,0-43.2,19.9-57.6,33.3S0,217.1,0,217.1h14.9l-3,14.4c0,0,13.4-7.9,12.9-6 c-0.5,2-1.5,14.9-0.5,11.9c1-3,41.2-59.6,48.2-63.1C79.5,170.9,76.5,165.4,76.5,165.4z",
    fill: "#3C2311"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.8 55.1L421.7 17.4 402.4 9.9 393.9 35.3 360.6 0 358.2 31.3 333.8 38.2 333.8 55.1 303.5 55.1 318.4 81.5 284.1 85.9 288.6 96.9 259.3 93.4 277.2 127.2 239.4 127.2 248.4 150.5 362.6 93.9z",
    fill: "#3C2311"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change2_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4,365.2h58.3l18.5-100.7h132.5l21.2,100.7h60.9v-147l46.4-91.4l51.7,57l41.1-57l-94.1-88.8L251.5,148H85 c-14.1,0-25.6,11.4-25.6,25.6V365.2z",
    fill: "#8A623B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "change3_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 416.8,
    cy: 98.9,
    fill: "inherit",
    r: 8.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorse);
export default __webpack_public_path__ + "static/media/horse.305d0410efa0b614518efa805890c6bc.svg";
export { ForwardRef as ReactComponent };